//这里公开所有的对外接口

import * as THREE from 'three';
import {UIApi} from '@/js/apis/uiapi.js';
import {DrawApi} from '@/js/apis/draw.js';

export class ApiManager{
	constructor(web3DView){
		this.web3DView = web3DView;		
		this.uiApi = new UIApi(this.web3DView);
		this.drawApi = new DrawApi(this.web3DView);
	}

}


// WEBPACK FOOTER //
// ./src/plugins/js/apis/apimanager.js